"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERRORS = void 0;
exports.ERRORS = {
    noWeb3Provider: 'Web3 provider missing',
    noInfuraId: 'Infura ID missing',
    noNetworkId: 'Network ID missing',
    wrongNetworkId: 'Network ID not supported',
};
